module.exports = __webpack_public_path__ + "static/media/arrow-right-icon.5a330ae0.svg";